export default {
  ROOT: 'storeTable/',
  SET_PAGINATION: 'SET_PAGINATION',
  SET_PAGINATION_TOTAL_ITEMS: 'SET_PAGINATION_TOTAL_ITEMS',
  SET_ITEMS: 'SET_ITEMS',
  SET_LOADER: 'SET_LOADER',
  SET_PAGINATION_ROW_PER_PAGE: 'SET_PAGINATION_ROW_PER_PAGE',
  QUERY_ITEMS: 'QUERY_ITEMS',
};
